export const Log = {
    e(...message: any) {
        console.error(...message);
    },
};
